<template>
  <div
    v-if="showWindowBar"
    class="fixed z-[1500] box-border flex h-8 w-full items-center justify-between bg-gray-900 px-5"
  >
    <MenuHeader is-in-utility></MenuHeader>

    <div class="flex items-center gap-2.5">
      <TButton
        v-if="fullscreenButtonShowed"
        id="toggle-fullscreen-id"
        @click="toggleFullScreen"
      >
        <template #icon>
          <MaximizeIcon v-if="!isFullscreen" />
          <MinimizeIcon v-else />
        </template>
      </TButton>

      <TButton v-if="closeButtonShowed" @click="closeWithoutSave">
        <template #icon>
          <CloseLarge />
        </template>
      </TButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import MenuHeader from "@/forms/components/MenuHeader/MenuHeader.vue";
  import { useTopBarStore } from "@/stores/topBar";
  import {
    CloseLarge,
    Maximize as MaximizeIcon,
    Minimize as MinimizeIcon,
  } from "@topol/icons";
  import { TButton } from "@topol/twig-ui";
  import { useFullscreen } from "@vueuse/core";
  import { computed } from "vue";

  const topBarStore = useTopBarStore();
  const { isFullscreen, toggle, isSupported } = useFullscreen();

  const windowBar = computed((): Array<string> => {
    return topBarStore.windowBar;
  });

  const showWindowBar = computed((): boolean => {
    return topBarStore.showWindowBar;
  });

  const fullscreenButtonShowed = computed((): boolean => {
    return windowBar.value.includes("fullscreen");
  });

  const closeButtonShowed = computed((): boolean => {
    return windowBar.value.includes("close");
  });

  function toggleFullScreen() {
    if (isSupported.value) {
      toggle();
    }
  }

  function closeWithoutSave() {
    const message = {
      type: "callback",
      action: "onClose",
      data: {
        args: [],
      },
    };

    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }
</script>
